import axios from '../../http/axios/index.js';

export default {
  SET_BEARER(state, accessToken) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
  },
  UPDATE_POPUP(state, show) {
    state.showPopup = show;
  },
  UPDATE_POPUP_FLAG(state, show) {
    state.popupFlag = show;
  },
};
